import React from 'react';
import { useIntl } from 'umi';
import { Button, Modal } from 'tea-component';
import { getTranslateText, keyArrRender } from '../components/GamesDetails/NewsActivity/utils';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import './index.scss';

interface IMoreModalProps extends IBaseProps {
  lang: 'original' | 'en' | 'cn' | (string & {});
  keywords?: string[];
  title: string;
  showBottomBtns?: boolean;
  visible: boolean;
  data: any;
  close: () => void;
}

const MoreModal: React.FC<IMoreModalProps> = (porps) => {
  const { lang, keywords, title, showBottomBtns = true, visible, data, close } = porps;

  const { formatMessage } = useIntl();

  const time = data?.posted_on ?? '';
  const desc = data?.news_type ?? '';
  const subTitle = getTranslateText(lang, { original: data?.title, en: data?.title_en, cn: data?.title_cn });
  const content = keyArrRender(
    getTranslateText(lang, { original: data?.content, en: data?.content_en, cn: data?.content_cn }),
    keywords,
  );

  return (
    <Modal className='dbi-more-box' size={500} visible={visible} caption={title} onClose={close}>
      <Modal.Body>
        {(subTitle || time || desc) && (
          <div className="dbi-more-modal">
            <div className="dbi-more-modal-title">{subTitle}</div>
            <div className="dbi-more-modal-flex">
              <div className="text-time">{time}</div>
              <div className="text-desc">{desc}</div>
            </div>
          </div>
        )}
        <div className="dbi-more-modal-context" dangerouslySetInnerHTML={{ __html: content }}></div>
      </Modal.Body>
      {showBottomBtns && (
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              window.open(data?.url);
              close();
            }}
          >
            {formatMessage({ id: 'dbi_company_go_to' })}
          </Button>
          <Button type="weak" onClick={close}>
            {formatMessage({ id: 'dbi_cancel' })}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default MoreModal;
